import {
  AgChartOptions,
  AllCommunityModule,
  ModuleRegistry,
} from 'ag-charts-community';
import { AgCharts } from 'ag-charts-react';
import { Box } from 'components/ui';
import { useMemo, useState } from 'react';
import styled from 'styled-components';

ModuleRegistry.registerModules([AllCommunityModule]);

const ChartContainer = styled(Box)<{ $height: number }>`
  width: 100%;
  height: ${({ $height }) => ($height ? `${$height}px` : '100%')};
  min-width: 0;
  min-height: 0;
  position: relative;
`;

interface PieChartProps {
  data?: any[];
  title?: string;
  showTitle?: boolean;
  height?: number;
  legendPosition?: 'top' | 'right' | 'bottom' | 'left';
  showLegend?: boolean;
  innerRadius?: number;
  categoryKey?: string;
  seriesKey?: string;
  colors?: string[];
  valueSuffix?: string;
}

export const PieChart = ({
  data,
  title,
  showTitle = true,
  height = 300,
  legendPosition = 'bottom',
  showLegend = true,
  innerRadius,
  categoryKey = 'category',
  seriesKey = 'count',
  colors = ['#2196f3', '#4caf50', '#ff9800', '#e91e63', '#9c27b0'],
  valueSuffix,
}: PieChartProps) => {
  const [styleContainer, setStyleContainer] = useState<HTMLDivElement | null>(
    null
  );

  const options: AgChartOptions = useMemo(() => {
    return {
      theme: 'ag-default',
      data: data,
      minHeight: 400,
      tooltip: {
        enabled: true,
      },
      title: {
        text: title || '',
        enabled: showTitle,
        fontSize: 18,
        fontWeight: 'bold',
      },
      series: [
        {
          type: 'pie',
          angleKey: seriesKey,
          legendItemKey: categoryKey,
          sectorLabelKey: seriesKey,
          innerRadius,
          sectorLabel: {
            color: 'white',
            fontWeight: 'bold',
            ...(valueSuffix && {
              formatter: ({ value }: { value: number }) =>
                `${value}${valueSuffix}`,
            }),
          },
          fills: colors,
          strokeWidth: 0,
        },
      ],
      legend: {
        position: legendPosition,
        enabled: showLegend,
        preventHidingAll: true,
        maxHeight: 100,
        minHeight: 100,
        maxWidth: 300,
        item: {
          label: {
            maxLength: 200,
          },
        },
        orientation: 'vertical',
      },
    };
  }, [
    data,
    title,
    showTitle,
    legendPosition,
    showLegend,
    innerRadius,
    categoryKey,
    seriesKey,
    colors,
    valueSuffix,
  ]);

  return (
    <ChartContainer ref={setStyleContainer} $height={height}>
      {styleContainer && (
        <AgCharts options={{ ...options, styleContainer } as AgChartOptions} />
      )}
    </ChartContainer>
  );
};
